import { render } from "./IrAdd.vue?vue&type=template&id=32647478&scoped=true"
import script from "./IrAdd.vue?vue&type=script&lang=js"
export * from "./IrAdd.vue?vue&type=script&lang=js"

import "./IrAdd.vue?vue&type=style&index=0&id=32647478&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32647478"]])

export default __exports__